/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SalesPublicStripeWebhookService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any
     * @throws ApiError
     */
    public postSalesPublicStripeWebhookHandle(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/public/sales/stripe/webhook',
        });
    }

}
